module.exports = __webpack_public_path__ + "img/252650c.png";